module.exports = __webpack_public_path__ + "vax-notifs-mockup.svg?efd820ce3bb74e7a831a5114a86da224";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/vax-notifs-mockup.svg
// module id = 308
// module chunks = 0